// extracted by mini-css-extract-plugin
export default {"text":"Auhms7z6","title":"Xx6C8Tyj","small":"x8TZJd9D","ink":"M3vY7O_v"};